import { camelizeKeys } from "humps";
import uniqBy from "lodash/uniqBy";
import { ParentChildValues } from "PFApp/helpers/get_parent_child_skills_map";
import { FetchCustomValueParentChildValuesResponse } from "PFCore/services/custom_values";
import { MatchedCustomValue, PureCustomValue } from "PFCore/types";

type ParentChildCustomValueData = (MatchedCustomValue["customValue"] | PureCustomValue)[];

export type CombinedParentChildData = {
  parents: ParentChildCustomValueData;
  children: ParentChildCustomValueData;
};

const MAX_PARENT_CHILD_SKILLS = 5;

export const combineExistingAndMissingParentChildSkills = (
  data: FetchCustomValueParentChildValuesResponse,
  parentChildProfileValues?: ParentChildValues
): CombinedParentChildData => {
  const profileParentValues = camelizeKeys(
    parentChildProfileValues?.parentValues || []
  ) as MatchedCustomValue["customValue"][];
  const profileChildValues = camelizeKeys(
    parentChildProfileValues?.childValues || []
  ) as MatchedCustomValue["customValue"][];

  return {
    parents: uniqBy([...profileParentValues, ...data.parents], "id").slice(0, MAX_PARENT_CHILD_SKILLS),
    children: uniqBy([...profileChildValues, ...data.children], "id").slice(0, MAX_PARENT_CHILD_SKILLS)
  };
};
